namespace GeniuzPOS.Inventory {
    export interface IcStockBacProcessingForm {
        PostFg: Serenity.EnumEditor;
        PosOrIcProcessing: Serenity.EnumEditor;
        PostSequenceFg: Serenity.EnumEditor;
        TotalDocCount: Serenity.IntegerEditor;
        ProcessedTranCount: Serenity.IntegerEditor;
        FinishDate: Serenity.DateEditor;
    }

    export class IcStockBacProcessingForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.IcStockBacProcessing';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!IcStockBacProcessingForm.init)  {
                IcStockBacProcessingForm.init = true;

                var s = Serenity;
                var w0 = s.EnumEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.DateEditor;

                Q.initFormType(IcStockBacProcessingForm, [
                    'PostFg', w0,
                    'PosOrIcProcessing', w0,
                    'PostSequenceFg', w0,
                    'TotalDocCount', w1,
                    'ProcessedTranCount', w1,
                    'FinishDate', w2
                ]);
            }
        }
    }
}
